import { render, staticRenderFns } from "./userbehavior.vue?vue&type=template&id=01a4f734&scoped=true&"
import script from "./userbehavior.vue?vue&type=script&lang=js&"
export * from "./userbehavior.vue?vue&type=script&lang=js&"
import style0 from "./userbehavior.vue?vue&type=style&index=0&id=01a4f734&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a4f734",
  null
  
)

export default component.exports